// extracted by mini-css-extract-plugin
module.exports = {"button":"ResetPasswordForm_button__2J3Wi","content":"ResetPasswordForm_content__1Zj_h"};